module.exports = __webpack_public_path__ + "static/media/redoBlue.cc6d7644.svg";